'use client';
import { jsx } from 'react/jsx-runtime';
import '@digdir/designsystemet-web';
import { forwardRef, useContext } from 'react';
import { Context } from './tabs.js';

/**
 * A single item in a Tabs component.
 *
 * @example
 * <TabsTab value='1'>Tab 1</TabsTab>
 */
const TabsTab = forwardRef(function TabsTab({ value, className, onClick, onClickCapture, ...rest }, ref) {
    const { onChange, getPrefixedValue, isControlled, currentValue } = useContext(Context);
    return (
    // biome-ignore lint/a11y/noStaticElementInteractions: ds-tabs IS interactive
    jsx("ds-tab", { "aria-controls": rest['aria-controls'] ?? getPrefixedValue?.(value), "data-value": value, ref: ref, suppressHydrationWarning // Since <ds-tablist> adds attributes
        : true, onClickCapture: (e) => {
            onClickCapture?.(e);
            if (isControlled && currentValue !== value) {
                e.preventDefault();
            }
        }, onClick: (e) => {
            if (e.isTrusted || !isControlled || currentValue !== value) {
                onChange?.(value); // Only call onChange is user actually clicked, not when programmatically clicked/controlled
            }
            onClick?.(e);
        }, class: className, ...rest, children: rest.children }));
});

export { TabsTab };
